export default __webpack_public_path__ + "static/media/productValues2.9f5b2856.svg";